// Noodle-inspired difficulty levels
export const DIFFICULTIES = {
  rookie: {
    label: "Rookie Slinger",
    tagline: "Still learnin' which end of the noodle's which.",
    base: 600,
    jitter: 150,
    bountyDollars: 50,
    color: "#3c7024",
  },
  bandit: {
    label: "Saucy Bandit",
    tagline: "Slings sauce so hot it'll melt your hat.",
    base: 400,
    jitter: 100,
    bountyDollars: 250,
    color: "#7c3f0a",
  },
  sheriff: {
    label: "Sheriff of Slurps",
    tagline: "The fastest noodle this side of the supermarket.",
    base: 250,
    jitter: 60,
    bountyDollars: 1000,
    color: "#e60808",
  },
};

// Order matters: Chicken first, then Beef
export const TEAMS = {
  chicken: {
    label: "Team Chicken",
    tagline: "This Chicken's got beef.",
    color: "#3c7024",
    image: "/brand/cup-chicken.png",
    render: "/brand/cup-chicken-render.png",
  },
  beef: {
    label: "Team Beef",
    tagline: "This Beef's no chicken.",
    color: "#7c3f0a",
    image: "/brand/cup-beef.png",
    render: "/brand/cup-beef-render.png",
  },
};

export const ROUNDS_PER_MATCH = 5;
export const ROUNDS_TO_WIN = 3;

export const sampleAiTime = (difficulty) => {
  const cfg = DIFFICULTIES[difficulty];
  const offset = (Math.random() * 2 - 1) * cfg.jitter;
  return Math.max(120, Math.round(cfg.base + offset));
};

export const randomDelayMs = () => 1500 + Math.random() * 2500;

export const verdict = (playerMs, aiMs, foul) => {
  if (foul) return { win: false, label: "TOO EARLY, PARTNER" };
  if (playerMs == null) return { win: false, label: "MISSED THE SLURP" };
  if (playerMs < aiMs) return { win: true, label: "SAUCED 'EM" };
  return { win: false, label: "SMOKED" };
};
